(function () {
  var CART_SECTION = 'cart-helper';
  var ANIM_MS = 580;
  var crosssellRefreshTimer;
  var cartChangeInFlight = false;

  function formatMoney(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return '₹ 0';
    return '₹ ' + Math.round(value / 100).toLocaleString('en-IN');
  }

  function getCartSidebar() {
    return document.getElementById('site-cart-sidebar');
  }

  function isMiniCartActive() {
    var sidebar = getCartSidebar();
    return !!(sidebar && sidebar.classList.contains('tb-mini-cart'));
  }

  function updateCartCount(count) {
    var countEl = document.querySelector('[data-header-cart-count]');
    var cartCount = document.querySelector('#AjaxCartForm [data-cart-count]');
    if (cartCount) cartCount.textContent = count;
    if (countEl) countEl.textContent = count;

    var itemCountEl = document.querySelector('[data-tb-mc-item-count]');
    if (itemCountEl) {
      itemCountEl.textContent = count + (count === 1 ? ' Item' : ' Items');
    }
  }

  function syncCartEmptyState(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var footer = document.querySelector('#AjaxCartSubtotal .cart__footer');
    var cartItems = document.querySelector('#AjaxCartForm .cart-items');

    if (footer) {
      footer.classList.toggle('cart--empty', count === 0);
    }

    if (cartItems && count === 0 && !cartItems.querySelector('.tb-mc__empty')) {
      cartItems.innerHTML = '<p class="tb-mc__empty">Your bag is empty — add something you love.</p>';
    }
  }

  function scheduleCrosssellRefresh() {
    clearTimeout(crosssellRefreshTimer);
    crosssellRefreshTimer = setTimeout(refreshCrosssellOnly, 200);
  }

  function initCartItemMedia(root) {
    root = root || document.querySelector('#AjaxCartForm .cart-items');
    if (!root) return;

    root.querySelectorAll('.lazy-image img').forEach(function (img) {
      if (img.dataset.src && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
        img.src = img.dataset.src;
      }
      img.classList.add('lazyloaded');
      img.style.opacity = '1';
      img.style.transform = 'none';
    });

    if (typeof window.preloadImages === 'function') {
      window.preloadImages(root);
    }
  }

  function initCrosssellMedia(root) {
    root = root || document.querySelector('#AjaxCartForm .tb-mc-crosssell');
    if (!root) return;

    root.querySelectorAll('.tb-pcard__track').forEach(function (track) {
      track.scrollLeft = 0;
    });

    root.querySelectorAll('.lazy-image img').forEach(function (img) {
      if (img.dataset.src && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
        img.src = img.dataset.src;
      }
      img.classList.add('lazyloaded');
      img.style.opacity = '1';
      img.style.transform = 'none';
    });

    if (typeof window.preloadImages === 'function') {
      window.preloadImages(root);
    }
  }

  function refreshCrosssellOnly() {
    return fetch('/?section_id=' + CART_SECTION)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCrosssell = doc.querySelector('.tb-mc-crosssell');
        var scroll = document.querySelector('#AjaxCartForm .tb-mc__scroll');
        var currentCrosssell = document.querySelector('#AjaxCartForm .tb-mc-crosssell');

        if (!scroll) return;

        if (newCrosssell) {
          var crosssellHtml = newCrosssell.outerHTML;
          if (currentCrosssell) {
            currentCrosssell.outerHTML = crosssellHtml;
          } else {
            scroll.insertAdjacentHTML('beforeend', crosssellHtml);
          }
          initCrosssellMedia();
        } else if (currentCrosssell) {
          currentCrosssell.remove();
        }
      });
  }

  function changeCartLine(itemEl, quantity) {
    if (cartChangeInFlight) return Promise.resolve();
    if (!itemEl || !itemEl.dataset.id) return Promise.resolve();

    cartChangeInFlight = true;

    var cartForm = document.getElementById('AjaxCartForm');
    var innerForm = cartForm && cartForm.querySelector('form.cart');
    if (innerForm) innerForm.classList.add('processing');

    if (quantity === 0) {
      itemEl.classList.add('is-removing');
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: itemEl.dataset.id, quantity: Math.max(0, quantity) })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || cart.status === 422) {
          throw new Error((cart && cart.description) || 'Cart update failed');
        }

        syncTotalsFromCart(cart);
        updateCartCount(cart.item_count);
        syncCartEmptyState(cart);

        return refreshMiniCartSection().then(function () {
          if (cart.item_count > 0) {
            scheduleCrosssellRefresh();
          }
          if (window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.schedule === 'function') {
            window.TBFreeGiftGuard.schedule();
          }
          return cart;
        });
      })
      .catch(function () {
        return refreshMiniCartSection();
      })
      .finally(function () {
        cartChangeInFlight = false;
        if (innerForm) innerForm.classList.remove('processing');
        if (itemEl.parentNode) itemEl.classList.remove('is-removing');
      });
  }

  function bindCartItemActions() {
    var cartForm = document.getElementById('AjaxCartForm');
    if (!cartForm || cartForm.dataset.tbCartActions === 'true') return;
    cartForm.dataset.tbCartActions = 'true';

    cartForm.addEventListener(
      'click',
      function (e) {
        if (!isMiniCartActive()) return;

        var item = e.target.closest('.cart-item');
        if (!item || !cartForm.contains(item)) return;

        if (e.target.closest('.remove')) {
          e.preventDefault();
          e.stopPropagation();
          changeCartLine(item, 0);
          return;
        }

        if (e.target.closest('.less')) {
          e.preventDefault();
          e.stopPropagation();
          if (item.getAttribute('data-tb-free-gift') === '1' || item.classList.contains('tb-cart-item-gift')) {
            return;
          }
          var lessQty = parseInt(item.querySelector('.qty')?.value || item.dataset.qty || '1', 10) - 1;
          if (lessQty >= 0) changeCartLine(item, lessQty);
          return;
        }

        if (e.target.closest('.more')) {
          e.preventDefault();
          e.stopPropagation();
          if (item.getAttribute('data-tb-free-gift') === '1' || item.classList.contains('tb-cart-item-gift')) {
            return;
          }
          var moreQty = parseInt(item.querySelector('.qty')?.value || item.dataset.qty || '0', 10) + 1;
          changeCartLine(item, moreQty);
        }
      },
      true
    );
  }

  function refreshMiniCartSection() {
    return fetch('/?section_id=' + CART_SECTION)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var form = doc.getElementById('AjaxCartForm');
        var subtotal = doc.getElementById('AjaxCartSubtotal');
        var currentForm = document.getElementById('AjaxCartForm');
        var currentSubtotal = document.getElementById('AjaxCartSubtotal');

        if (form && currentForm) {
          currentForm.innerHTML = form.innerHTML;
        }

        if (subtotal && currentSubtotal) {
          currentSubtotal.innerHTML = subtotal.innerHTML;
        }

        var cartCount = document.querySelector('#AjaxCartForm [data-cart-count]');
        if (cartCount) {
          updateCartCount(parseInt(cartCount.textContent, 10) || 0);
        }

        initCartItemMedia();
        initCrosssellMedia();

        var count = parseInt(
          document.querySelector('#AjaxCartForm [data-cart-count]')?.textContent || '0',
          10
        );
        syncCartEmptyState({ item_count: count });

        if (typeof window.scheduleFreeGiftsUpdate === 'function') {
          window.scheduleFreeGiftsUpdate();
        } else if (typeof window.updateFreeGiftsText === 'function') {
          window.updateFreeGiftsText();
        }

        if (window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.schedule === 'function') {
          window.TBFreeGiftGuard.schedule();
        }
      });
  }

  function syncTotalsFromCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    syncCartEmptyState(cart);

    var subtotalEl = document.querySelector('[data-tb-mc-subtotal]');
    var totalEl = document.querySelector('[data-tb-mc-total]');

    if (subtotalEl) {
      var paid =
        window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.getPaidSubtotalCents === 'function'
          ? window.TBFreeGiftGuard.getPaidSubtotalCents(cart)
          : cart.items_subtotal_price;
      subtotalEl.textContent = formatMoney(paid);
    }
    if (totalEl) {
      var displayTotal =
        window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.getDisplayTotalCents === 'function'
          ? window.TBFreeGiftGuard.getDisplayTotalCents(cart)
          : cart.total_price;
      totalEl.textContent = formatMoney(displayTotal);
    }

    if (typeof window.scheduleFreeGiftsUpdate === 'function') {
      var paidRupees =
        window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.getPaidSubtotalCents === 'function'
          ? window.TBFreeGiftGuard.getPaidSubtotalCents(cart) / 100
          : typeof cart.total_price === 'number'
            ? cart.total_price / 100
            : undefined;
      window.__tbLastCartForGifts = cart;
      window.scheduleFreeGiftsUpdate(paidRupees);
    } else if (typeof window.updateFreeGiftsText === 'function') {
      window.__tbLastCartForGifts = cart;
      window.updateFreeGiftsText(
        window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.getPaidSubtotalCents === 'function'
          ? window.TBFreeGiftGuard.getPaidSubtotalCents(cart) / 100
          : typeof cart.total_price === 'number'
            ? cart.total_price / 100
            : undefined
      );
    }
  }

  function patchCartDrawerAnimation() {
    var sidebar = getCartSidebar();
    if (!sidebar || sidebar.__tbMcAnimPatched) return;
    sidebar.__tbMcAnimPatched = true;

    if (typeof sidebar.hide === 'function') {
      var originalHide = sidebar.hide.bind(sidebar);
      sidebar.hide = function () {
        originalHide();
        clearTimeout(sidebar.__tbMcHideTimer);
        sidebar.__tbMcHideTimer = setTimeout(function () {
          if (!sidebar.classList.contains('sidebar--opened')) {
            sidebar.style.display = 'none';
          }
        }, ANIM_MS);
      };
    }
  }

  function disableThemeCartFormHandlers() {
    var cartFormEl = document.getElementById('AjaxCartForm');
    if (!cartFormEl || !isMiniCartActive()) return;

    cartFormEl.ajaxifyCartItems = function () {};
    cartFormEl.updateCartQty = function () {};
  }

  function init() {
    disableThemeCartFormHandlers();
    bindCartItemActions();
    initCartItemMedia();
    initCrosssellMedia();
    patchCartDrawerAnimation();
  }

  window.TBMiniCart = {
    refresh: refreshMiniCartSection,
    syncTotals: syncTotalsFromCart,
    formatMoney: formatMoney
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(patchCartDrawerAnimation, 300);
})();
